module.exports = __webpack_public_path__ + "media/base/customer_company_small-f70a3d16.svg";